var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-delivery"},[_c('img',{attrs:{"src":"src/assets/img/map.png","alt":""}}),_vm._v(" "),_c('h4',[_vm._v("Envíos a todo Chile.")])])
}]

export { render, staticRenderFns }